// removed by extract-text-webpack-plugin
module.exports = {"sidebar_image":"_2JYYI6zW2lecrZRS-V0O1W"};


//////////////////
// WEBPACK FOOTER
// ./programm/style.module.less
// module id = 1000
// module chunks = 0